import { useState } from "react";
import { Textareawithsteroids } from "./EnvironmentReport";
import { HeaderShow } from "./ESGmain";
import './socialreport.css';
import '../index.css';
import './index.css';

const SocialReport = () => {
    const [showContent,setShowContent] = useState(false)
    return ( 
        <div className="socialreport mt-2">
            
            <Workplace/>
            <Health/>
            <DiversityAndInclusion/>
            <ActiveParticipation/>
            <HeaderShow text={"Your Social Aim"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="col-md-11 mx-auto">
                <div className="esg__companyinfo__header mb-1 socialaim">
                    <h6>What does your company passionately care about in this category ? Have you created a benchmark just for that? </h6>
                </div>
                <div className="esg__leader__value mt-2 p-5 pt-3 pb-3 socialaim">
                    <Textareawithsteroids
                        maxLength={2300}
                        keyHighlight={"yoursocialaim"}
                    />
                </div>
                </div>:null
            }
        </div>
     );
}

const Workplace = ( ) => {
    const [showContent,setShowContent] = useState(false)
    const trainingsupport = "How does your company support both training new talent and keeping the gold, until retirement, and perhaps supporting them in staying even longer than the formal retirement age?"
    const retention = "How do you support lifelong learning and retention of employees?"
    const internalrotation = "Do you have internal rotation possibilities and a diversity promoting promotion programme?"
    const turnover = "Employee turnover rate(%):"
    const sickleave = "Employee sick leave (%):"
    const sickleavestats = "Does your company keep statistics over sick leave and have active support programmes to support quic return and prevention. Are \"ov-dage\" implemented so the employee can take a time out if desperately needed?:"
    const enhancingstrategy = "Does your company have a strategy for enhancing employee work environment?"
    const socialextracurricular = "Does the company have any extracurricular activities related to social, then please add them in here:"
    return (
        <>
            <HeaderShow text={"Workplace"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="esg__companyinfo__values esg__workplace">
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{trainingsupport}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={trainingsupport}
                                maxLength={1200}
                                keyHighlight={"trainingsupport"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__highlight">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{retention}</h6>
                        </div> 
                        <div className="esg__highlight__value p-4 mb-1">
                            <Textareawithsteroids
                                question={retention}
                                maxLength={1200}
                                keyHighlight={"retention"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{internalrotation}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={internalrotation}
                                maxLength={1200}
                                keyHighlight={"internalrotation"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{turnover}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={turnover}
                                maxLength={4}
                                keyHighlight={"turnover"}
                                minHeight={"100px"}
                                placeholder={"NB: Employee turnover rate = Numbers of employees who left / Average number of employee * 100"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{sickleave}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={sickleave}
                                maxLength={4}
                                keyHighlight={"sickleave"}
                                minHeight={"100px"}
                                placeholder={"NB: Sick leave = Sick leave days / Full Time Equivalent ( FTE )"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{sickleavestats}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={sickleavestats}
                                maxLength={1200}
                                keyHighlight={"sickleavestats"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{enhancingstrategy}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={enhancingstrategy}
                                maxLength={1200}
                                keyHighlight={"enhancingstrategy"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{socialextracurricular}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={socialextracurricular}
                                maxLength={1200}
                                keyHighlight={"socialextracurricular"}
                            />
                        </div>
                    </div>
                </div>:null
            }
        </>
    )
}

const Health = () => {
    const [showContent,setShowContent] = useState(false)
    const employeehealth = "How does you support employees health in the work environment?"
    const offgassing = "Do you consider offgassing from paint, furnitures, textiles in regards to indoor climate etc?"
    const smoking = "Is it a non-smoker environment? If not, when is it the plan to be?"
    const physicalactivity = "Is there a reasonable interchange between physical and stationary activity? If not, how does the company suppport enough rest/activity during the day?"
    const meals = "If the company offers meals during the workday, how far are you from reaching 100% plant-based?"
    const physicalpain = "Percentage of employees with work-related physical pain:"
    const stress = "Percentage of employees with stress symptomps:"
    const physicalwellbeing = "Does your company have a strategy for promoting physical wellbeing ? Y/N"
    const mentalwellbeing = "Does your company have a strategy for promoting mental wellbeing ? Y/N"
    const holistic = "Does your company offer a holistic health coaching to the employees including them given the chance to learn more about plant-based diet and what nutrients are needed for a well-functioning body?"
    const benefit = "Other health related benefits?"
    return (
        <>
            <HeaderShow text={"Health"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent?
            
                <div className="esg__companyinfo__values esg__scopes">
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{employeehealth}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={employeehealth}
                                maxLength={1200}
                                keyHighlight={"employeehealth"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__highlight">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{offgassing}</h6>
                        </div> 
                        <div className="esg__highlight__value p-4 mb-1">
                            <Textareawithsteroids
                                question={offgassing}
                                maxLength={1200}
                                keyHighlight={"offgassing"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{smoking}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={smoking}
                                maxLength={1200}
                                keyHighlight={"smoking"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{physicalactivity}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={physicalactivity}
                                maxLength={1200}
                                keyHighlight={"physicalactivity"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{meals}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={meals}
                                maxLength={1200}
                                keyHighlight={"meals"}
                                placeholder={"Total food sourced\n% plant based"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{physicalpain}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={physicalpain}
                                maxLength={1200}
                                keyHighlight={"physicalpain"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{stress}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={stress}
                                maxLength={1200}
                                keyHighlight={"stress"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{physicalwellbeing}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={physicalwellbeing}
                                maxLength={1200}
                                keyHighlight={"physicalwellbeing"}
                                placeholder={"If yes please elaborate"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{mentalwellbeing}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={mentalwellbeing}
                                maxLength={1200}
                                keyHighlight={"mentalwellbeing"}
                                placeholder={"If yes please elaborate"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{holistic}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={holistic}
                                maxLength={1200}
                                keyHighlight={"holistic"}
                                placeholder={"If yes please elaborate"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{benefit}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={benefit}
                                maxLength={1200}
                                keyHighlight={"benefit"}
                            />
                        </div>
                    </div>
                </div>:null
            }
        </>
    )
}

const DiversityAndInclusion = () => {
    const [showContent,setShowContent] = useState(false)
    const nationalities = "Which nationalities are represented in staff?"
    const languages = "Which languages are supported in the workplace?"
    const genderdivision = "Gender division in employees:"
    const specialneeds = "Do you actively support employment of special needs employees, eg. With Aspergers, Autism, ADHD, people with a physical handicap or other - how ?"
    const agebreakdown = "Age breakdown of Employees"
    const inclusion = "Describe how your company support Inclusion, so everyone thrives in the workplace?"
    const diversity = "How is diversity supported and encouraged in general inside and outside the company?"
    const disability = "Does your product support usage of people with disabilities. eg. Blindness, reduced mobility etc. - how?"
    const tenure = "Tenure breakdown of employees"
    return ( 
        <>
            <HeaderShow text={"Diversity & Inclusion"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="esg__companyinfo__values esg__scopes">
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{nationalities}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={nationalities}
                                maxLength={1200}
                                keyHighlight={"nationalities"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__highlight">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{languages}</h6>
                        </div> 
                        <div className="esg__highlight__value p-4 mb-1">
                            <Textareawithsteroids
                                question={languages}
                                maxLength={1200}
                                keyHighlight={"languages"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{genderdivision}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={genderdivision}
                                maxLength={1200}
                                keyHighlight={"genderdivision"}
                                minHeight={"100px"}
                                placeholder={"E.g. Female: 20\n Male: 21\n Non-binary: 22 \nOther: 23"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{specialneeds}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={specialneeds}
                                maxLength={1200}
                                keyHighlight={"specialneeds"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{agebreakdown}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={agebreakdown}
                                maxLength={1200}
                                keyHighlight={"agebreakdown"}
                                minHeight={"100px"}
                                placeholder={"E.g. <20 : 20\n 31 - 40: 21\n 41 -50: 22 "}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{inclusion}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={inclusion}
                                maxLength={1200}
                                keyHighlight={"inclusion"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{diversity}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={diversity}
                                maxLength={1200}
                                keyHighlight={"diversity"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{disability}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={disability}
                                maxLength={1200}
                                keyHighlight={"disability"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{tenure}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={tenure}
                                maxLength={1200}
                                keyHighlight={"tenure"}
                                minHeight={"150px"}
                                placeholder={"1-3 year of employment:\n3-7 year of employment:\n7-10 year of employment:\n More than 10 years of employment"}
                            />
                        </div>
                    </div>
                </div>:null
            }
        </>
    )
}

const ActiveParticipation = () => {
    const [showContent,setShowContent] = useState(false)
    const nutrientflows = "How do you support end-user ease of returning materials into the nutrient flows?"
    const supplychain = "How many of these benefits mentioned above does your company also offer to employees in the supply chain companies ?"
    return ( 
        <>
            <HeaderShow text={"Active Participation"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="esg__companyinfo__values esg__workplace">
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{nutrientflows}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={nutrientflows}
                                maxLength={1200}
                                keyHighlight={"nutrientflows"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__highlight">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{supplychain}</h6>
                        </div> 
                        <div className="esg__highlight__value p-4 mb-1">
                            <Textareawithsteroids
                                question={supplychain}
                                maxLength={1200}
                                keyHighlight={"supplychain"}
                                minHeight={"100px"}
                                placeholder={"X out of 27 questions\nAnd how many suppliers comply: %"}
                            />
                        </div>
                    </div>
                </div>:null
            }
            </>
    )
}
 
export default SocialReport;